<div class="md-form md-outline">
  <input
    mdbInput
    type="password"
    class="form-control"
    [formControl]="control"
    [id]="id"
    [mdbValidate]="true"
    [validateSuccess]="false"
    autocomplete="new-password"
    jhiMarkAsterisk
  />
  <label [for]="id">{{ label }}</label>
  <mdb-error *ngIf="control && (control.dirty || control.touched)">
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
    <span *ngIf="control.hasError('minlength')" jhiTranslate="components.inputs.password.minLength" [translateValues]="{ nb: control!.errors!['minlength'].requiredLength }"></span>
    <span *ngIf="control.hasError('confirmedValidator')" jhiTranslate="components.inputs.confirmPassword.confirmedValidator"></span>
  </mdb-error>
  <span
    *ngIf="control && control.hasError('passwordStrength') && (control.dirty || control.touched)"
    class="error-message password-strength-error"
    [class.second-error]="control.hasError('minlength')"
    jhiTranslate="components.inputs.password.passwordStrengthError"
  ></span>
</div>
